import HttpRequest from "@/api/axios";
import moment    from 'moment'

const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL2);
const axios1 = new HttpRequest(process.env.VUE_APP_API_BASE_URL);

export default {
    h5login(data) {
        return axios1.request({
            url: "user/login-wx-wap",
            method: "post",
            data
        });
    },
    userinfolist(data) {
        return axios1.request({
            url: "user/userinfo",
            method: "post",
            data
        });
    },
    upsteps(data) {
        return axios1.request({
            url: "user/up-steps",
            method: "post",
            data
        });
    },
    upstepsgroup(data) {
        return axios1.request({
            url: "user/up-steps-group",
            method: "post",
            data
        });
    },
    grouplist(data) {
        return axios1.request({
            url: "user/grouplist",
            method: "post",
            data
        });
    },
    getUserInfo(data) {
        return axios.request({
            url: "user/user-info",
            method: "get",
            params: data
        });
    },
    editUserInfo(data) {
        return axios.request({
            url: "user/edit-info",
            method: "put",
            data
        });
    },
    getRecords: async (params) => {
        const res = await axios.request(
            {
                url: `sports-item-user`,
                params: Object.assign({ expand: 'sportsItem,sportsItemSub' }, params),
                method: 'GET'
            }
        );
        if (+res.status === 200) {
            res.data.list.forEach((item, index) => {
                item.create_time = moment(item.create_time * 1000).format('MM月DD日 HH:mm');
            });

        }
        return res;
    },
}
